var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"strategic__contain"},[_c('div',{staticClass:"banner"},[_vm._v("11")])])
}]

export { render, staticRenderFns }